import React from 'react';

import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import { dangerColor, primaryColor } from "assets/jss/material-dashboard-pro-react.jsx";

import Add from "@material-ui/icons/Add";
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import { CircularProgress, Fab } from "@material-ui/core";
import Empty from 'components/Empty/Empty';
import EditOrAddContact, { ContactStateObject } from './EditOrAddContact';
import SmallModal from 'components/Modal/SmallModal';
import Primary from "components/Typography/Primary.jsx";
import Api from '../../../../api/Api.js';
import CustomerEndpoints from '../../../../api/CustomerEndpoints';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column'
    },
    flexRow: {
        display: 'flex',
        flexDirection: 'row'
    }
};


class ViewContactsList extends React.Component {

    state = {
        selectedContact: null,
        selectedContactId: null,
        showAddForm: false,
        showEditForm: false,
        showAreYouSure: false
    }

    typeName = () => this.props.type === "business" ? "Business Contact" :
        this.props.type === "technical" ? "Technical Contact" :
            "Financial Contact";

    renderAddForm() {
        return (
            <EditOrAddContact
                    type_name={this.typeName()}
                    customer_id={this.props.customer_id}
                    type={this.props.type}
                    isOpen={this.state.showAddForm}
                    close={() => this.setState({ showAddForm: false })}
                    ref="add_form"
                    refresh={this.props.refresh}
                />
        );
    }

    render() {
        if (!this.props.contacts || this.props.contacts.length === 0) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, flexDirection: 'column' }}>
                    <Empty style={{ flex: 1 }} title="No Contacts to Show..." subtitle="You should probably add some" />
                    <Fab
                        color="primary"
                        style={{ margin: '6px 6px 10px 6px', marginLeft: 'auto' }}
                        onClick={() => this.setState({ showAddForm: true })}
                    >
                        <Add />
                    </Fab>
                    {this.renderAddForm()}
                </div>
            );
        } else if (!this.state.selectedContact) {
            this.setState({ selectedContact: this.props.contacts[0].contact, selectedContactId: this.props.contacts[0].contact_id });
            return <CircularProgress color="secondary" />;
        }

        const { classes } = this.props;
        return (
            <GridContainer style={{ width: '100%' }}>
                <GridItem xs={12}>
                    <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                    >
                        <InputLabel
                            htmlFor="sub_contact"
                            className={classes.selectLabel}
                        >
                            Select Contact
                        </InputLabel>
                        <Select
                            MenuProps={{
                                className: classes.selectMenu
                            }}
                            classes={{
                                select: classes.select
                            }}
                            onChange={(event) => this.setState({ selectedContactId: event.target.value, selectedContact: this.props.contacts.find(x => x.contact_id == event.target.value).contact })}
                            inputProps={{
                                name: "sub_contact",
                                id: "sub_contact"
                            }}
                            color="rose"
                            value={this.state.selectedContactId}
                        >
                            <MenuItem disabled classes={{ root: classes.selectMenuItem }}>Select Contact</MenuItem>
                            {
                                this.props.contacts.map(x =>
                                    <MenuItem
                                        key={x.contact_id}
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value={x.contact_id}>
                                        {x.contact.name} {x.contact.surname || ""}
                                    </MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                </GridItem>
                <GridItem xs={12}>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            <h4><strong>Name:</strong></h4>
                            {this.state.selectedContact.surname ? <h4><strong>Surame:</strong></h4> : null}
                            {this.state.selectedContact.contact_number ? <h4><strong>Phone No:</strong></h4> : null}
                            <h4><strong>Email:</strong></h4>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                            <h4>{this.state.selectedContact.name}</h4>
                            {this.state.selectedContact.surname ? <h4>{this.state.selectedContact.surname}</h4> : null}
                            {this.state.selectedContact.contact_number ? <h4><a href={`tel:${this.state.selectedContact.contact_number}`}>{this.state.selectedContact.contact_number}</a></h4> : null}
                            <h4><a href={`mailto:${this.state.selectedContact.email.emailaddress}`}>{this.state.selectedContact.email.emailaddress}</a></h4>
                        </GridItem>
                        <GridItem xs={12}>
                            <Fab
                                color="primary"
                                style={{ float: "right", margin: '6px 6px 10px 6px' }}
                                onClick={() => this.setState({ showAddForm: true })}
                            >
                                <Add />
                            </Fab>
                            <Fab
                                color="secondary"
                                style={{ float: 'right', margin: '6px 6px 10px 6px' }}
                                onClick={() => this.setState({ showEditForm: true })}
                            >
                                <Edit />
                            </Fab>
                            <Fab
                                color="secondary"
                                style={{ margin: '6px 6px 10px 6px', backgroundColor: dangerColor }}
                                onClick={() => this.setState({ showAreYouSure: true })}
                            >
                                <Delete />
                            </Fab>
                        </GridItem>
                    </GridContainer>
                </GridItem>

                {this.renderAddForm()}

                {
                    this.state.showEditForm ?
                        <EditOrAddContact
                            contact={{ ...this.state.selectedContact, email: this.state.selectedContact.email.emailaddress }}
                            type={this.props.type}
                            type_name={this.typeName()}
                            customer_id={this.props.customer_id}
                            isOpen={this.state.showEditForm}
                            close={() => this.setState({ showEditForm: false })}
                            ref="edit_form"
                            refresh={() => {
                                this.props.refresh().then(() => this.setState({ selectedContact: this.props.contacts[0].contact, selectedContactId: this.props.contacts[0].contact_id }));
                            }}
                        />
                        : null
                }

                <SmallModal
                    isOpen={this.state.showAreYouSure}
                    close={() => this.setState({ showAreYouSure: false })}
                    accept={() => {
                        Api.get(CustomerEndpoints.deleteContact, { id: this.state.selectedContactId, customer_id: this.props.customer_id, type: this.props.type })
                            .then(() => {
                                this.setState({ showAreYouSure: false }, () => this.props.refresh().then(() => this.setState({ selectedContact: this.props.contacts[0] ? this.props.contacts[0].contact : null, selectedContactId: this.props.contacts[0] ? this.props.contacts[0].contact_id : null })));
                            })
                    }}
                >
                    Are you sure you want to remove <span style={{ color: primaryColor }}>{this.state.selectedContact.name}{this.state.selectedContact.surname ? " " + this.state.selectedContact.surname : ""}</span> from this customers' list of <span style={{ color: primaryColor }}>{this.typeName()}s</span>?
                </SmallModal>

            </GridContainer>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(ViewContactsList);